import { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { WorkspaceHome } from "./pages/home";
import { DossierLayout } from "./pages/layout";
import { OverviewPage } from "./pages/overview";
import { DocumentsPage } from "./pages/documents";
import { ReadinessPage } from "./pages/readiness";
import { SectionPage } from "./pages/section";
import { ChapterPage } from "./pages/chapter";
import { AuditsPage } from "./pages/audits";
import { PlanPage } from "./pages/plan";
import { TeamPage } from "./pages/team";
import { PlanningPage } from "./pages/planning";
import { DatapointsPage } from "./pages/datapoints";
import { ReferentialPage } from "./pages/referential";
import { LoginPage } from "./pages/login";
import { UsersPage } from "./pages/users";
import { ContributePage } from "./pages/contribute";
import { ReportPage, SynthesisPage } from "./pages/report";
import { ReportTemplatePage } from "./pages/report-template";
import { AuditTrailPage, HistoryPage, IssuesPage } from "./pages/system";
import "@fontsource-variable/inter";
import "./workspace.css";

/** The dossier workspace. It does not need the prototype runtime, so it renders immediately. */
export default function WorkspaceRoutes() {
  // The shared FR/EN switch broadcasts "sfcr:render"; re-render on it.
  const [, setRevision] = useState(0);
  useEffect(() => {
    const rerender = () => setRevision(value => value + 1);
    window.addEventListener("sfcr:render", rerender);
    return () => window.removeEventListener("sfcr:render", rerender);
  }, []);

  return <Routes>
    <Route path="/" element={<WorkspaceHome />} />
    <Route path="/contribute/:token" element={<ContributePage />} />
    <Route path="/login" element={<LoginPage />} />
    <Route path="/dossiers/:dossierId" element={<DossierLayout />}>
      <Route index element={<OverviewPage />} />
      <Route path="documents" element={<DocumentsPage />} />
      <Route path="readiness" element={<ReadinessPage />} />
      <Route path="sections/:code" element={<SectionPage />} />
      <Route path="chapters/:code" element={<ChapterPage />} />
      <Route path="issues" element={<IssuesPage />} />
      <Route path="audits" element={<AuditsPage />} />
      <Route path="report" element={<ReportPage />} />
      <Route path="report/template" element={<ReportTemplatePage />} />
      <Route path="plan" element={<PlanPage />} />
      <Route path="team" element={<TeamPage />} />
      <Route path="planning" element={<PlanningPage />} />
      <Route path="datapoints" element={<DatapointsPage />} />
      <Route path="referentiel" element={<ReferentialPage />} />
      <Route path="users" element={<UsersPage />} />
      <Route path="synthese" element={<SynthesisPage />} />
      <Route path="history" element={<HistoryPage />} />
      <Route path="audit" element={<AuditTrailPage />} />
    </Route>
  </Routes>;
}
